// src/components/OmniCine/Timeline/Clips/ClipDuckOverlay.tsx
import React from "react";

type Region = { start:number; end:number; gainDb:number; attack:number; release:number };
type Props = {
  clipStart: number;  // clip.start (sec)
  clipDur: number;    // clip.dur (sec)
  pxPerSec: number;
  regions?: Region[];
};

export default function ClipDuckOverlay({ clipStart, clipDur, pxPerSec, regions }: Props) {
  if (!regions?.length) return null;
  const W = clipDur * pxPerSec;

  return (
    <div className="absolute inset-0 pointer-events-none">
      {regions.map((r, i) => {
        const s = Math.max(clipStart, r.start);
        const e = Math.min(clipStart + clipDur, r.end);
        if (e <= s) return null;
        const left = (s - clipStart) * pxPerSec;
        const w = Math.max(1, (e - s) * pxPerSec);

        return (
          <div
            key={i}
            className="absolute top-0 h-full rounded-[6px]"
            style={{
              left,
              width: w,
              background:
                "linear-gradient(to bottom, rgba(34,211,238,.16), rgba(34,211,238,.08))",
              outline: "1px dashed rgba(34,211,238,.55)",
              outlineOffset: "-2px",
              boxShadow: "inset 0 0 0 1px rgba(34,211,238,.35)",
            }}
            title={`Duck ${r.gainDb}dB â€¢ atk ${r.attack}s â€¢ rel ${r.release}s`}
          />
        );
      })}
    </div>
  );
}

